import type { ReactNode } from 'react';

export const symbol_auto_towing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M40-298v-60q0-13 8.5-21.5T70-388h410L100-682v117q0 13-8.5 21.5T70-535q-13 0-21.5-8.5T40-565v-166q0-17 14.5-26t29.5-1l470 259v-271q0-13 8.5-21.5T584-800h108q14 0 26 5.5t20 16.5l168 201q7 8 10.5 18t3.5 21v240q0 13-8.5 21.5T890-268h-67q0 45-31.5 76.5T715-160q-45 0-76.5-31.5T607-268H349q0 45-31.5 76.5T241-160q-45 0-76.5-31.5T133-268H70q-13 0-21.5-8.5T40-298Zm247 76q19-19 19-46t-19-46q-19-19-46-19t-46 19q-19 19-19 46t19 46q19 19 46 19t46-19Zm474 0q19-19 19-46t-19-46q-19-19-46-19t-46 19q-19 19-19 46t19 46q19 19 46 19t46-19ZM614-560h228L692-740h-78v180Z"
		/>
	</svg>
);
